import {Dispatch} from "redux";
import ICourier from "./ICourier";
import IOrder from "../IOrder";

export function  saveCouriers(couriers:ICourier[]){
    return (dispatch: Dispatch) => {

        return dispatch({
            type: 'SAVE_COURIERS',
            couriers
        });
    };
}
export function  saveOpenedOrders(openedOrders:IOrder[]){
    return (dispatch: Dispatch) => {

        return dispatch({
            type: 'SAVE_OPENED_ORDERS',
            openedOrders
        });
    };
}
export function  saveOrderHistory(orders:IOrder[]){
    return (dispatch: Dispatch) => {

        return dispatch({
            type: 'SAVE_ORDER_HISTORY',
            orders
        });
    };
}